const SET_FEATURE_PLAN_LIST = 'SET_FEATURE_PLAN_LIST';
const SET_UPLOAD_TEMPLATE_SUCCESS_MESSAGE = 'SET_UPLOAD_TEMPLATE_SUCCESS_MESSAGE';
const SET_UPLOAD_TEMPLATE_ERROR_MESSAGE = 'SET_UPLOAD_TEMPLATE_ERROR_MESSAGE';
const SET_UPLOAD_TEMPLATE_FAILURE_MESSAGE = 'SET_UPLOAD_TEMPLATE_FAILURE_MESSAGE';
const SET_SIDEBAR_PARAMS = 'SET_SIDEBAR_PARAMS';
const SET_CURRENT_YEAR = 'SET_CURRENT_YEAR';

export const FEATURE_PLAN_ACTION_TYPES = {
    SET_FEATURE_PLAN_LIST,
    SET_UPLOAD_TEMPLATE_SUCCESS_MESSAGE,
    SET_UPLOAD_TEMPLATE_ERROR_MESSAGE,
    SET_UPLOAD_TEMPLATE_FAILURE_MESSAGE,
    SET_SIDEBAR_PARAMS,
    SET_CURRENT_YEAR,
};
